import type { ReactNode } from 'react'
import type { Editor } from '@tiptap/core'
import { useEditorState } from '@tiptap/react'
import { cn } from 'cn'

export default function MarkButton({
  editor,
  format,
  label,
  children,
}: React.PropsWithChildren<{
  editor: Editor
  format: 'bold' | 'italic'
  label: string
}>): ReactNode {
  const active = useEditorState({
    editor,
    selector: ({ editor: ed }) => ed.isActive(format),
  })

  return (
    <button
      aria-pressed={active}
      className={cn(
        'relative z-10 inline-flex items-center px-2 py-1 text-text-primary/50 [&_svg]:fill-current',
        active && 'text-text-primary',
      )}
      onMouseDown={event => {
        event.preventDefault()
        event.stopPropagation()
        editor.chain().focus().toggleMark(format).run()
      }}
      title={label}
      type="button"
    >
      {children}
    </button>
  )
}
